export const DEFAULT_USER_IMAGE = 'assets/default/user.png';
export const DEFAULT_LOGO_IMAGE = 'assets/default/logo-placeholder.png';

export const DEFAULT_PRODUCT_IMAGE = 'assets/default/product-logo.png';

export * from './roles.constant';
export * from './base64.constant';
export * from './system-languages.constant';
// https://github.com/microsoft/LUIS-Samples/blob/master/documentation-samples/tutorials/job-phrase-list.csv
